import PropTypes from 'prop-types'

export interface ApiResponse {
  data?: any
  errors?: any
}

export interface BankAccount {
  bank_account_number_last4?: string
}

export interface Category {
  en_name: string
  es_name: string
  icon_library?: string
  icon?: string
  id: number
}

export interface Group {
  id: number
  name: string
}

export interface CharityLocation {
  id?: number
  name?: string
  formatted_address?: string
  city?: string
  state?: string
  zip?: string
  latitude?: number
  longitude?: number
  google_location_id?: string
  google_description?: string
  created_at?: string
  updated_at?: string
}

export interface Charity {
  id?: number
  ein?: string
  organization_name: string
  also_known_as?: string | null
  mission?: string | null
  website_url?: string | null
  logo_url?: string | null
  address_line_1?: string
  address_line_2?: string | null
  addressLine1?: string
  addressLine2?: string
  city?: string
  state?: string
  zip?: string
  county?: string
  latitude?: number
  longitude?: number
  external_donation_url?: string | null
  amazon_wishlist_url?: string | null
  facebook_link?: string | null
  linkedin_link?: string | null
  instagram_link?: string | null
  youtube_link?: string | null
  tiktok_link?: string | null
  volunteer_location?: CharityLocation | null
  donation_location?: CharityLocation | null
  visitor_location?: CharityLocation | null
  available?: boolean
  name?: string
  registered?: boolean
  registration_status?: string
}

export interface CharityRegistration {
  id: number
  charity: Charity
  status: string
}

export interface Pledge {
  id: number
  amount: number
  state: 'pending' | 'accepted' | 'declined' | 'expired' | 'cancelled'
  payment_status?:
    | 'unpaid'
    | 'pending'
    | 'in_progress'
    | 'processing'
    | 'paid'
    | 'failed'
  stripe_payment_method_id?: string
  payment_method_type?: 'card' | 'ach'
  payment_method_last_four?: string
  event?: {
    id?: number
    title?: string
    event_start_date?: string
  }
}

export const CharityType = PropTypes.shape({
  addressLine1: PropTypes.string,
  addressLine2: PropTypes.string,
  available: PropTypes.bool,
  county: PropTypes.string,
  ein: PropTypes.string,
  name: PropTypes.string,
  registered: PropTypes.bool,
})

export default {
  CharityType,
}
